module.exports = __webpack_public_path__ + "img/2_seguridad.ec0155f0.jpg";